var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-table',{staticClass:"main-table",attrs:{"headers":_vm.headers,"items":_vm.filteredRows},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"table-cell"},[_vm._v("\n          "+_vm._s(item.id)+"\n        ")]),_c('div',{staticClass:"table-cell"},[_vm._v("\n          "+_vm._s(item.name)+"\n        ")])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }